import { ContextArray } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'
import { call, takeLatest } from 'redux-saga/effects'

import { Project } from '../../../models/project'
import { gotProjectAction } from '../../slices/project'

export const addProjectDataToDataDogContext = (project: Project) => {
    if (!project.id || !project.portal_number) return
    const sessionDigIds: ContextArray = []
    const sessionPortalNumbers: ContextArray = []

    const globalContext = datadogRum.getGlobalContext()

    if (globalContext.lastDigitizerNum === project.id) return

    if (globalContext) {
        sessionDigIds.push(...((globalContext.sessionDigitizerNums as ContextArray) || []))
        sessionPortalNumbers.push(...((globalContext.sessionPortalNums as ContextArray) || []))
    }
    if (!sessionDigIds.includes(project.id)) sessionDigIds.push(project.id)
    if (!sessionPortalNumbers.includes(project.portal_number)) {
        sessionPortalNumbers.push(project.portal_number)
    }

    datadogRum.setGlobalContext({
        sessionDigitizerNums: sessionDigIds,
        sessionPortalNums: sessionPortalNumbers,
        lastDigitizerNum: project.id,
        lastPortalNum: project.portal_number,
    })
}

export function* handleLoggingProject(action: ReturnType<typeof gotProjectAction>) {
    try {
        yield call(addProjectDataToDataDogContext, action.payload)
    } catch (error) {
        yield call(console.error, error)
    }
}

export function* watchForGotProjectActionToLogProjectInDataDog() {
    yield takeLatest(gotProjectAction.type, handleLoggingProject)
}
